module.exports = __webpack_public_path__ + "static/tshqmarketing-26986fcd8e2b2c9b9a0a2899b578cef7.png";